export default __webpack_public_path__ + "static/media/movimiento-interno.aa3cbb20.svg";